import React, {useEffect, useRef, useState} from 'react';

import CardHeader from '../../components/common/card-header/CardHeader';
import {Card, FlexItem, FlexLayout, Spinner, StackLayout, Text} from '@salt-ds/core';
import StepTracker from '../../components/common/StepTracker';
import Constants from '../../components/common/Constants';
import '../CommonCard.css';
import {useIntl} from 'react-intl';
import CardAlert from '../../components/common/card-alert/CardAlert';
import OnlineProfileRegistrationCreateUserIdForm from './OnlineProfileRegistrationCreateUserIdForm';
import {useLocation, useNavigate} from "react-router";

function OnlineProfileRegistrationCreateUserId() {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const mainRef = useRef(null);

  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.step2.page.title'});
    if (mainRef.current) {
      mainRef.current.focus();
    }
    if (location.state?.from !== Constants.onlineProfileRegistrationAuthenticate) {
      navigate('/');
    }
  }, [intl,navigate,location]);
  const [hasError, setHasError] = useState(false);


  const [headerContent, setHeaderContent] = useState(<CardAlert status={"error"}
    setHasError={setHasError}></CardAlert>);
  const [errorMessage, setErrorMessage] = useState("The information you provided is not correct. Please try again in 30 minutes.");
  const[isLoading, setIsLoading] = useState(false);

  const showErrorOnPage = (error) => {
    setErrorMessage(error);
    setHasError(true);
  }

  return (
    <main ref={mainRef} tabIndex="-1">
    <FlexLayout className={"page-content"}>
      {isLoading ? (
          <FlexItem className="spinner-wrapper">
            <Spinner data-testid="spinner-loading" aria-label="loading" role="status" size="medium" style={{marginLeft: "50%"}} />
          </FlexItem>
      ) : (
          <FlexItem className={`error-wrapper ${hasError ? 'visible' : ''}`}>
            <div>
              <CardAlert status={"error"} setHasError={setHasError}>{errorMessage}</CardAlert>
            </div>
          </FlexItem>
      )}

      <FlexItem>
        <Card className="card-wrapper">
          <FlexItem className="card-content">
            <StackLayout gap={3}>
              <CardHeader heading={Constants.onlineProfileRegistrationTitle}
                subheading={Constants.onlineProfileRegistrationStep2Title}
                style={{maxWidth: "24.5rem"}} />

              <StepTracker label1={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step1'})} step1="completed"
                label2={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step2'})} step2="active"
                label3={intl.formatMessage({id: 'logon.ui.onlineProfileRegistration.flow.step3'})} step3="pending" />
              <FlexItem>
                <Text>
                  {Constants.onlineProfileRegistrationStep2InstructionalText}
                </Text>
              </FlexItem>
              <OnlineProfileRegistrationCreateUserIdForm showErrorOnPage={showErrorOnPage} isLoading={isLoading} setIsLoading={setIsLoading}/>
            </StackLayout>
          </FlexItem>
        </Card>
      </FlexItem>
    </FlexLayout>
    </main>

  );
}

export default OnlineProfileRegistrationCreateUserId;